module.exports = __webpack_public_path__ + "img/hook-2.51ea9469.png";